import { LogoProps } from "../../../types/ai/logos";
import { SengiColors } from "../../../utils/SengiColors";
import { isFeatureEnabled } from "../../../features";

// "FREE"-Abzeichen ist Teil der Kosten-Anzeige ("kostenlos" ergibt nur Sinn, wenn Kosten sichtbar
// sind) - Masterplan Paket 3: nur noch mit creditsUi (Dev). Zentral hier fuer alle Aufrufer.
const SHOW_FREE_BADGE = isFeatureEnabled("creditsUi");

const FreeLogo= ({
    size = 18,
    className = "p-1",
    style = {}
}: LogoProps) => {
    if (!SHOW_FREE_BADGE) return null;
    const resolvedSize =
        typeof size === "number" ? `${size}px` : size;

    const numericSize =
        typeof size === "number" ? size : parseFloat(size);

    const fontSize = numericSize * 0.55;

    return (
        <div
            className={className}
            style={{
                height: resolvedSize,
                width: `calc(${resolvedSize} * 1.8)`,
                borderRadius: `calc(${resolvedSize} * 0.35)`,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                background: `linear-gradient(225deg, ${SengiColors.sng_success} 0%, ${SengiColors.sng_success} 55%, ${SengiColors.sng_success} 100%)`,
                boxShadow: "0 8px 20px rgba(62, 212, 61,0.28)",
                userSelect: "none",
                ...style
            }}
        >
            <span
                style={{
                    color: SengiColors.sng_anthracite,
                    fontWeight: 900,
                    fontSize: fontSize,
                    lineHeight: 1,
                    letterSpacing: "0.04em",
                    fontFamily: "Arial, Helvetica, sans-serif",
                    textTransform: "uppercase",
                    textShadow: "0 2px 10px rgba(0,0,0,0.18)"
                }}
            >
                Free
            </span>
        </div>
    );
};

export default FreeLogo;